import toast from "react-hot-toast";
import { AxiosError } from "axios";
import { handleApi } from "../utils/handleApi";

export default function SentryTestPage() {
  const handleError = () => {
    toast.error("This is your first error!");
    throw new Error("This is your first error!");
  };

  const testErrorWithTrigger = async () => {
    const mockError = {
      response: {
        status: 404,
        statusText: "Not Found",
        data: {
          trigger: "order_not_found",
          message: "Order Not Found",
        },
      },
      config: { url: "/api/order/fake-id" },
    } as AxiosError;

    await handleApi(Promise.reject(mockError), false);
  };

  const testErrorWithoutTrigger = async () => {
    const mockError = {
      response: {
        status: 500,
        statusText: "Internal Server Error",
        data: {
          error: "Something went wrong in the server",
        },
      },
      config: { url: "/api/broken-endpoint" },
    } as AxiosError;

    await handleApi(Promise.reject(mockError), false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-50 to-orange-50 p-8">
      <div className="text-center max-w-2xl">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">
          🚨 Sentry Test Page 🚨
        </h1>
        <p className="text-sm text-gray-600 mb-8">
          Abre la consola del navegador para ver los logs
        </p>

        <div className="space-y-6">
          {/* Error no manejado */}
          <div className="bg-white p-6 rounded-lg shadow-md">
            <button
              className="w-full px-8 py-4 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-bold text-lg rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              onClick={handleError}
            >
              💥 Error no manejado
            </button>
            <p className="mt-3 text-gray-600 text-sm">
              Error que se propaga sin control →{" "}
              <span className="font-bold text-red-600">SÍ va a Sentry</span>
            </p>
          </div>

          {/* Error con trigger */}
          <div className="bg-white p-6 rounded-lg shadow-md">
            <button
              className="w-full px-8 py-4 bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-white font-bold text-lg rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              onClick={testErrorWithTrigger}
            >
              Error CON trigger (controlado)
            </button>
            <p className="mt-3 text-gray-600 text-sm">
              Error con "trigger" en response.data →{" "}
              <span className="font-bold text-yellow-600">NO va a Sentry</span>
            </p>
            <p className="mt-1 text-xs text-gray-500">
              Verás: "Error controlado (trigger)"
            </p>
          </div>

          {/* Error sin trigger */}
          <div className="bg-white p-6 rounded-lg shadow-md">
            <button
              className="w-full px-8 py-4 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-bold text-lg rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              onClick={testErrorWithoutTrigger}
            >
              Error SIN trigger (NO controlado)
            </button>
            <p className="mt-3 text-gray-600 text-sm">
              Error sin "trigger" (bug real) →{" "}
              <span className="font-bold text-purple-600">SÍ va a Sentry</span>
            </p>
            <p className="mt-1 text-xs text-gray-500">
              Verás: "Error NO controlado reportado a Sentry"
              <br />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
